import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=72ac6b70&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=72ac6b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac6b70",
  null
  
)

export default component.exports